module.exports = __webpack_public_path__ + "media/images/jpool-logo-10959877.svg";